import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CYCLE_RUNS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('CYCLE_RUNS');
export const CYCLE_RUNS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CYCLE_RUNS_CRUD_ACTION_CONSTANTS
);
